import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import s from './NoAccessScreen.module.css';

export default function NoAccessScreen() {
   const navigate = useNavigate();

  return (
    <div className={s.container}>
      <div className={s.content}>
        <div className={s.icon}>
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
          </svg>
        </div>
        <h1 className={s.title}>Доступ запрещен</h1>
        <p className={s.message}>
          У вас недостаточно прав для просмотра этой страницы.
          <br />
          Обратитесь к администратору для получения доступа.
        </p>
        <div className={s.actions}>
          <Button 
            variant="primary"
            onClick={() => navigate(-1)}
            className={s.button}
          >
            Вернуться назад
          </Button>
          <Button 
            variant="outline-primary"
            onClick={() => navigate('/')}
            className={s.button}
          >
            На главную
          </Button>
        </div>
      </div>
    </div>
  );
};